










































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Dashboard extends Vue
{
	@Prop({ default: '' }) title!: string
	@Prop() projects!: Array<Project>
	@Prop({ default: false }) dark!: boolean

	get titleClasses()
	{
		return {
			'is-size-3': true,
			'mb-2': true,
			'has-text-light': this.dark
		}
	}
}
